import React from 'react';
import { getTenantDetails } from 'utils/routeUtils';

const UserInfo = () => {
  const tenantDetails = getTenantDetails();
  const { name, resource_access } = tenantDetails;
  const roles = resource_access?.mrv_api_auth_client?.roles || [];
  return (
    <div
      className="d-none d-md-flex"
      style={{ flexDirection: 'column', alignItems: 'end' }}
    >
      <p className="m-0" style={{ fontSize: '14px' }}>
        {name}
      </p>
      <p className="m-0" style={{ fontSize: '11px', color: 'slategray' }}>
        Logged as {roles[0]}
      </p>
    </div>
  );
};

export default UserInfo;
